import { Routes } from '@angular/router'

import { WorkspaceEntityRoutes } from './workspace-entity-routes'
import { Workspace404Activator, WorkspaceActivator } from './workspace.resolvers'

import { MergeConflictsStore } from '../../merge-conflicts/stores/conflicts.store'
import { ApplicationMainLayoutRoutes } from '../../projects/application-main-layout-routes'

export const WorkspaceRoutes: Routes = [
  // WORKSPACE ENTITY ADMINISTRATION ROTUES
  // projects, libraries, themes, fonts, global media library, audit logs, users, groups
  {
    path: '',
    loadComponent: () =>
      import('@flowx/designer/modules/workspaces/workspace/workspace-main.component').then(
        ({ WorkspaceMainComponent }) => WorkspaceMainComponent
      ),
    canActivate: [WorkspaceActivator],
    children: WorkspaceEntityRoutes,
  },
  {
    path: '404',
    canActivate: [Workspace404Activator],
    loadComponent: () =>
      import('@flowx/designer/modules/core/error-page/error-page.component').then(
        ({ ErrorPageComponent }) => ErrorPageComponent
      ),
  },
  // APPLICATION ROUTES
  // processes, project data model, uit templates, functions, enumerations, substitution tags, media library,
  // notification templates, document templates, document intelligence, views, stages, allocations rules, data sources,
  // workflows, dependencies, configuration parameters
  {
    path: 'projects',
    canActivate: [WorkspaceActivator],
    children: [
      {
        path: '404',
        loadComponent: () =>
          import('@flowx/designer/modules/core/error-page/error-page.component').then(
            ({ ErrorPageComponent }) => ErrorPageComponent
          ),
      },
      {
        path: ':appId',
        loadComponent: () =>
          import(
            '@flowx/designer/modules/layout/components/application-main-layout/application-main-layout.component'
          ).then(({ FlxApplicationMainLayoutComponent }) => FlxApplicationMainLayoutComponent),
        providers: [MergeConflictsStore],
        children: ApplicationMainLayoutRoutes,
      },
    ],
  },
]
